import { render } from "./PhoneList.vue?vue&type=template&id=74a8648e"
import script from "./PhoneList.vue?vue&type=script&lang=js"
export * from "./PhoneList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__